<template>
    <DataTable
        :header="$t('summary')"
        :fields="fields"
        :items="request.getData() || []"
        :loading="request.getLoading()"
        :error="request.getError()"
        class="mb-4"
    >
        <template #headerSide>
            <div class="d-flex gap-3">
                <FormCategoryTreeSelect
                    ref="FormCategoryTreeSelect"
                    v-model="categories"
                    class="width-200"
                    @change="loadData()"
                />
            </div>
        </template>
        <template #cell(impressions)="{item}">
            <div>{{ item.impressions }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.impressions, item.compareImpressions))" /></div>
        </template>
        <template #cell(clicks)="{item}">
            <div>{{ item.clicks }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.clicks, item.compareClicks))" /></div>
        </template>
        <template #cell(quantity)="{item}">
            <div>{{ item.quantity }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.quantity, item.compareQuantity))" /></div>
        </template>
        <template #cell(cr)="{item}">
            <div>{{ $format.percent(item.quantity / item.clicks * 100) }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.quantity / item.clicks * 100, item.quantity_compare / item.clicks_compare * 100))" /></div>
        </template>
        <template #cell(amount)="{item}">
            <div>{{ item.amount }}</div>
            <div><Difference :difference="$format.percent(calcPercentDiff(item.amount, item.compareAmount))" /></div>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import { calcPercentDiff } from '@/utils/number';
    import Difference from '@/components/common/Difference.vue';
    import FormCategoryTreeSelect from '@/components/common/FormCategoryTreeSelect.vue';

    export default {
        name: 'ProductReport',
        components: {
            DataTable,
            Difference,
            FormCategoryTreeSelect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('space/ProductReports'),
                categories: [],
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'name', label: this.$t('product'), sortable: true },
                    { key: 'sku', label: this.$t('model'), sortable: true },
                    { key: 'impressions', label: this.$t('impressions'), sortable: true },
                    { key: 'clicks', label: this.$t('clicks'), sortable: true },
                    { key: 'quantity', label: this.$t('quantity2'), sortable: true },
                    { key: 'cr', label: this.$t('cr'), sortable: true },
                    { key: 'amount', label: this.$t('salesAmount'), sortable: true },
                ];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = { ...(this.timeRange || {}) };
                if (this.categories?.length) requestParams.categories = this.categories.join(',');
                return { urlParams, requestParams };
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
        },
        methods: {
            calcPercentDiff,
            loadData() {
                this.fetchReports();
            },
            fetchReports() {
                this.request.get(this.apiParams);
            },
        },
        created() {
            this.loadData();
        },
    };
</script>
